export default __webpack_public_path__ + "static/media/audioBalQtyError.b33e2968.mp3";